import { useCallback } from 'react';
import { Disaster } from '../store/ErisInformationStore';
import useApi from './axios/useErisApi';

function useDisastersRepo() {
  const { get } = useApi();

  const getLatestDisasterRequest = useCallback(
    async () => await get<Disaster>('api/er/disasters/latest'),
    [get]
  );

  const getPreviousDisasterRequest = useCallback(
    async () => await get<Disaster>('api/er/disasters/previous'),
    [get]
  );

  return {
    getLatestDisasterRequest,
    getPreviousDisasterRequest,
  };
}

export default useDisastersRepo;
